import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import * as ApexCharts from 'apexcharts';
@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.css'],
})
export class AdminDashboardComponent implements OnInit {
  // Define the API endpoints for fetching dashboard data and calculating scores
  panelOpenState = false;
  private getApi = environment.url + environment.dashboardGet;
  private scoreApi = environment.url + environment.calculateScore;
  // Constructor to inject necessary services
  constructor(
    private getdata: ValueService,
    private makeapi: ApiService,
    private notify: NotifyService,
    public dialog: MatDialog
  ) {}
  NotImplementColor = '#56c2e6';
  incubaterName;
  // This function is called when the component is initialized
  // It fetches the dashboard data and initializes the chart if scoring is enabled.
  ngOnInit(): void {
    this.incubaterName = sessionStorage.getItem('adminIncubName');
    this.getValue();
  }
  dashboardData: any = {};
  // This function fetches the dashboard data from the API
  // and updates the dashboardData property.
  getValue() {
    this.dashboardData = {};
    this.getdata.amizhthLoader('show');
    this.makeapi
      .method(
        this.getApi + 'id=' + sessionStorage.getItem('incubator'),
        '',
        'get'
      )
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        this.dashboardData = data;
        if (data.enableScoring == 2) {
          let str = data.tnimmTotalScore.toString();
          let val = str.split('.');
          this.grap(val[0], str);
        }
      });
  }
  timeout: any;
  // This function is called when the user clicks the "Generate Score" button.
  // It triggers the score generation process by calling the API.
  scoreGenerate() {
    this.getdata.amizhthLoader('show');
    this.makeapi
      .method(this.scoreApi + sessionStorage.getItem('incubator'), '', 'get')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        if (data.responseStatus == 'Success') {
          this.notify.notifysuccess(data.responseMessage);
          this.getValue();
        } else {
          this.notify.notifyError(data.responseMessage);
        }
      });
  }
  // This function creates a radial bar chart using ApexCharts.
  // It takes a value and a string to display in the chart.
  grap(val, str) {
    //
    let num: number = +val;
    let options = {
      series: [num],
      chart: {
        height: 350,
        type: 'radialBar',
        toolbar: {
          show: true,
        },
      },
      plotOptions: {
        radialBar: {
          startAngle: 0,
          endAngle: 360,
          hollow: {
            margin: 0,
            size: '70%',
            background: '#fff',
            image: undefined,
            imageOffsetX: 0,
            imageOffsetY: 0,
            position: 'front',
            dropShadow: {
              enabled: true,
              top: 3,
              left: 0,
              blur: 4,
              opacity: 0.24,
            },
          },
          track: {
            background: '#fff',
            strokeWidth: '67%',
            margin: 0, // margin is in pixels
            dropShadow: {
              enabled: true,
              top: -3,
              left: 0,
              blur: 4,
              opacity: 0.35,
            },
          },

          dataLabels: {
            show: true,
            name: {
              offsetY: -10,
              show: false,
              color: '#888',
              fontSize: '17px',
            },
            value: {
              formatter: function (val) {
                return str;
              },
              color: '#111',
              fontSize: '36px',
              show: true,
            },
          },
        },
      },
      fill: {
        type: 'gradient',
        gradient: {
          shade: 'dark',
          type: 'horizontal',
          shadeIntensity: 0.5,
          gradientToColors: ['#ABE5A1'],
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100],
        },
      },
      stroke: {
        lineCap: 'round',
      },
      labels: [],
    };
    let chart = new ApexCharts(document.querySelector('#chart'), options);
    chart.render();
  }
}
